module.exports = __webpack_public_path__ + "img/img_ serve4.ff42c69c.png";